export class ChangeDigitalSignature {

	success: boolean;
	message: string;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-digital-signature/model/change-digital-signature.ts